import { render, staticRenderFns } from "./pay_type_dialog.vue?vue&type=template&id=320bc41d"
import script from "./pay_type_dialog.vue?vue&type=script&lang=js"
export * from "./pay_type_dialog.vue?vue&type=script&lang=js"
import style0 from "./pay_type_dialog.vue?vue&type=style&index=0&id=320bc41d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports